import { getLoginStatusIcon } from "../../../utils/Icons";
import { getUsLocaleString } from "../../../utils/TimeUtils";

import "../cellUnit.css";
export type LastSyncTimeProps = {
  value?: string;
  loginStatus: string;
};

const LoginStatusCell: React.FC<LastSyncTimeProps> = ({ value, loginStatus }) => {
  

  return (
    <div className="cell-unit">
      <div className="overlay"></div>
      <img alt="icon" src={getLoginStatusIcon(loginStatus)}></img>
      <span className="body-medium">{value}</span>
    </div>
  );
};

export default LoginStatusCell;
